<div>
    <app-navbar></app-navbar>
    <router-outlet></router-outlet>
</div>

<ngx-loading style="z-index: 1000000;position: fixed;" [show]="loading" ></ngx-loading>
